import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { UserModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { UserBO } from './user.bo';

@Repository({
    boType: UserBO,
    apiController: TaggedUrl.join('user/permission', [Tags.Api])
})
export class UserRepositoryBase extends RepositoryBase<UserBO, UserModel> {
    public constructor(
        http: HttpService,
        private weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): UserBO {
        return new UserBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: UserModel) {
        return {
			userId: model.id,
			version: model.version,
			roleId: model.roleId,
			userPermissionKinds: model.userPermissionKinds
		};
    }

    protected async fromPlainObjectAsync(item: any): Promise<UserModel> {
        return new UserModel(pickBy({
			id: item.userId,
			firstName: item.firstName,
			lastName: item.lastName,
			roleId: item.roleId,
			roleName: item.roleName,
			userPermissionKinds: item.userPermissionKinds,
            version: item.version,
        }, val => val !== void 0));
    }
}
